import { render, staticRenderFns } from "./integraldoubling.vue?vue&type=template&id=18cd86fd&scoped=true"
import script from "./integraldoubling.vue?vue&type=script&lang=js"
export * from "./integraldoubling.vue?vue&type=script&lang=js"
import style0 from "./integraldoubling.vue?vue&type=style&index=0&id=18cd86fd&lang=less"
import style1 from "./integraldoubling.vue?vue&type=style&index=1&id=18cd86fd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd86fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cd86fd')) {
      api.createRecord('18cd86fd', component.options)
    } else {
      api.reload('18cd86fd', component.options)
    }
    module.hot.accept("./integraldoubling.vue?vue&type=template&id=18cd86fd&scoped=true", function () {
      api.rerender('18cd86fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/integraldoubling.vue"
export default component.exports